import { Pipe, PipeTransform } from '@angular/core';
import { FiscalIdKind } from 'src/app/core/models/common/fiscal-id.model';
import { LeadSummary } from 'src/app/core/models/lead/lead-summary.model';

@Pipe({
    name: 'piva',
    standalone: false
})
export class PivaPipe implements PipeTransform {

  transform(value: LeadSummary): string {
    return value?.fiscalIds.find(f => f.kind == FiscalIdKind.PartitaIva)?.value ?? ''
  }

}
